export default __webpack_public_path__ + "static/media/Vetfile-main-logo.5752e825.svg";